import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { UserIsActiveService } from '../services/user-is-active.service';

@Component({
  selector: 'app-temp',
  templateUrl: './temp.component.html',
  styleUrls: ['./temp.component.scss']
})
export class TempComponent implements OnInit {

  constructor(private router:Router, private global: GlobalService, private userIsActiveService: UserIsActiveService) {
    this.userIsActiveService.checkUserIsActive();
    this.router.navigateByUrl(this.global._active_route);
   }

  ngOnInit() {
  }

}
